/**
 * works
 */
'use strict';
import AppWorksEntry from '@/_modules/app_works_entry';

document.addEventListener('DOMContentLoaded', () => {
  new AppWorksEntry();
}, false);

window.addEventListener('load', () => {

}, false);

window.addEventListener('unload', () => {}, false);

window.addEventListener('pageshow', function(event){
  if (event.persisted) {
    window.location.reload();
  }
});
